import request from "@/apis/axios-instance";
import { AxiosResponse } from "axios";
import {
  ClassifyTableStructureResponse,
  RecommendEnLabelResponse,
} from "./types";
import { CellInfo } from "../table/types";
import { Dimension } from "@/types/mapping";

export const getTableStructure = async (
  cell_infos: CellInfo[],
): Promise<ClassifyTableStructureResponse> => {
  const response: AxiosResponse<ClassifyTableStructureResponse> =
    await request.post("/v1/ai/table_structure/classify", {
      cell_infos,
    });

  return response.data;
};

export const postRecommendEnLabel = async (
  workbookId: string,
  parentTagKey: string,
  roleKey: string,
  koreanLabel: string,
  dimension: Dimension,
): Promise<RecommendEnLabelResponse> => {
  const response: AxiosResponse<RecommendEnLabelResponse> = await request.post(
    "/v1/ai/recommend-en-label",
    {
      workbookId,
      parentTagKey,
      roleKey,
      koreanLabel,
      dimension,
    },
  );

  return response.data;
};
